import { createSlice } from "@reduxjs/toolkit";
const importstate=localStorage.getItem("Mode") === null ? false : JSON.parse(localStorage.getItem("Mode"));
export const theme =createSlice({
    initialState:importstate,
    name:"theme",
    reducers:{
        toggelTheme:(state,action)=>{
            return action.payload;
        }
    }
})
export const{toggelTheme}=theme.actions;
export default theme.reducer;